import styled from 'styled-components';
import { color } from 'styles/settings';
import { size, font } from 'styles/settings/typography';
import { withModifiers } from 'utils';

export const Container = styled.div`
  border-radius: 2px 10px 2px 2px;
  width: 257px;
  height: 61px;
  border: 1px solid ${color.neutral.grayLight};
  background-color: ${color.neutral.white};
  box-shadow: 0px 5px 10px ${color.neutral.blackWithOpacity(0.3)};
  cursor: default;
  font-size: ${size.sm};
  line-height: ${size.sm};
  color: ${color.neutral.plainBlack};
  ${font.content.semiBold};
  position: absolute;
  top: calc(50% - 30px);
  left: -300px;
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: row;
  height: 30px;
  top: 15px;
  padding-left: 15px;
  position: relative;
  justify-content: space-around;
  align-items: center;
`;

export const Button = styled.div`
  height: 30px;
  position: relative;
  cursor: pointer;
  transition: color 0.2s;
  color: inherit;

  ${withModifiers('disabled')`
        opacity: 0.3;
        pointer-events: none;
    `}

  svg {
    height: 100%;
  }

  :hover {
    color: ${color.brand.gold};
  }
`;

export const CheckButton = styled(Button)`
  top: 2px;

  :hover {
    color: ${color.brand.greenDark};
  }
`;

export const DeleteButton = styled(Button)`
  top: 1px;

  :hover {
    color: ${color.brand.red};
  }
`;

export const Textarea = styled.textarea`
  width: 140px;
  height: 31px;
  resize: none;
  border: none;
  padding: 5px;
  padding-top: 8px;
  font-size: inherit;
`;

export const Name = styled.p`
  width: 140px;
  height: 31px;
  border: none;
  padding: 5px;
  padding-top: 8px;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;
